import * as React from 'react';
import { ValidationSummary } from 'ui';
import styles from './detail-form-panel.scss';

/**
 * An expandable inline form to edit a child entity
 */
export const DetailFormPanel = (props:any) => (
  <div className={`row ${styles.detailFormPanel}`}>
    <ValidationSummary validationError={props.validation}/>
    {props.primaryKey && <h2 className={`row ${styles.primaryKey}`}> {`#${props.primaryKey?.value}`}</h2>}
    {props.children}
  </div>
);
